import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";

export interface DialogData_RecordingExportDialogInput extends MatDialogDataBaseInput {
	scenarioRecordingId: string;
	scenarioRecordingIdList: string[];
}

export interface DialogData_RecordingExportDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-recording-export-dialog",
	templateUrl: "./recording-export-dialog.component.html",
	styleUrls: ["./recording-export-dialog.component.scss"],
	standalone: false,
})
export class RecordingExportDialogComponent extends BasicMaterialDialog<
	RecordingExportDialogComponent,
	DialogData_RecordingExportDialogInput,
	DialogData_RecordingExportDialogOutput
> {
	T = Translations;
	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit(): void {}
}
